export const CART_ACTIONS = {
    INCREMENT_ITEM: "INCREMENT_ITEM",
    DECREMENT_ITEM: "DECREMENT_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    TRACK: "TRACK",
    ADD_MORE_ITEMS: "ADD_MORE_ITEMS",
    COOKING_REQUEST: "COOKING_REQUEST",
    SAVE_COOKING_CHANGES: "save_cooking_changes",
    REMOVE_COOKING_REQUEST: "remove_cooking_request",
    ADD_COOKING_REQUEST: "add_cooking_request",
    ITEM_SAVE_COOKING_CHANGES: "item_save_cooking_changes",
    ITEM_REMOVE_COOKING_REQUEST: "item_remove_cooking_request",
    ITEM_ADD_COOKING_REQUEST: "item_add_cooking_request",
    SCREEN: "SCREEN",
    UPDATE_CROSS_SELL_ITEM_HANDLER: "UPDATE_CROSS_SELL_ITEM_HANDLER",
};

export const ORDER_PLACEMENT_CONFIRMATION = {
    CARD_DURATION: 3000, // 3 seconds
    SCREEN_NAVIGATION_DELAY: 300, // 300ms (After card is closed)
};

export const SPECIAL_INSTRUCTIONS = {
    SUCCESS_MESSAGE: "Your cooking request was added",
    UPDATE_SUCCESS_MESSAGE: "Your cooking request was updated",
    ERROR_MESSAGE: "Cannot add cooking request. Please try again",
    REMOVE_SUCCESS_MESSAGE: "Your cooking request was removed",
    REMOVE_ERROR_MESSAGE: "Cannot remove cooking request. Please try again",
};

export const ERROR_RESPONSE_TYPE = "type.googleapis.com/swiggy.gandalf.widgets.v2.ErrorResponse";

export const CART_LABELS = {
    SUCCESS: "success",
    ERROR: "error",
};

export const COVERS_HALFCARD_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours
